import React, { useEffect, useState } from 'react';
import { IonContent, IonHeader, IonPage, IonLoading, IonItem, IonIcon, IonLabel } from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import LogItemList from '../components/LogItemList';
import { IActivityLogSearchResult, ILogSearch_Response } from '../domain/ActivityLog';
import HeaderSimple from '../components/HeaderSimple';
import { DataAccessService } from '../services/dataAccessService';
import { ActivityTypes, EnumTimePeriods, EnumPersons } from '../domain/enums';
import { Plugins } from '@capacitor/core';
import { alertCircleOutline } from 'ionicons/icons';

import './css/common.css';
import './css/Login.css';

const { Network } = Plugins;

const WatchResults: React.FC<RouteComponentProps> = ({history, location, match}) => {
    const [neededList, setNeededList] = useState([] as IActivityLogSearchResult[]);
    const [showLoading, setShowLoading] = useState(false);
    const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
    const [hasBeenRefreshed, setHasBeenRefreshed] = useState(false);

    useEffect(() => {
        Network.addListener("networkStatusChange", status => {
          setIsOnline(status.connected);
          if (status.connected)
            window.localStorage.setItem("online", "1");
          else
            window.localStorage.setItem("online", "0");
        });
    
        return () => Network.removeAllListeners();
    },[])

    useEffect(() => {
        let _token = window.localStorage.getItem("token");
        let _client = (window.localStorage.getItem("defaultClient")) ? String(window.localStorage.getItem("defaultClient")) : '-1';
        setShowLoading(true);
        if (_token && isOnline) {
            new DataAccessService().getActivityLogList(_token, _client, EnumTimePeriods.All.toString(), '', '',
                            EnumPersons.All.toString(), '', Number(ActivityTypes.All), true , '', false)
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let activityLogList = (JSON.parse(expectedData.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
                        if (activityLogList.length > 0) {
                            window.localStorage.setItem("activityLogListWatched", JSON.stringify(activityLogList));
                            setNeededList(activityLogList);
                            setShowLoading(false);
                        }
                        else {
                            setShowLoading(false);
                        }
                    }
                    else {
                        setShowLoading(false);
                    }
                },
                function (response) {
                    setShowLoading(false);
                }
            );
        }    
    }, [isOnline]);

     //update pin value after delete
    useEffect(() => {
        let _token = window.localStorage.getItem("token");
        let _client = window.localStorage.getItem("defaultClient") ? String(window.localStorage.getItem("defaultClient")) : '-1';
        if (hasBeenRefreshed && isOnline) {
          new DataAccessService().getActivityLogList(String(_token), _client, EnumTimePeriods.All.toString(), '', '', EnumPersons.All.toString(), '', Number(ActivityTypes.All), true , '', false)
            .then(
                function (expectedData) {
                    if (expectedData) {
                      let activityLogPinnedList = (JSON.parse(expectedData.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
                      if (activityLogPinnedList.length > 0) {
                        window.localStorage.setItem("pinValue", activityLogPinnedList.length.toString());
                      } 
                    }
                },
                function (response) {}
            );
        }
    },[hasBeenRefreshed, isOnline])

    const refresh = (id:number, isDelete:boolean = true) => {
        setHasBeenRefreshed(false);
        if (id !== 0 && isDelete) {
            setNeededList(neededList.filter((x) => x.ActivityLogID !== id)); 
            window.localStorage.setItem("activityLogListWatched", JSON.stringify(neededList));
            setHasBeenRefreshed(true);
        }
    }

    return (
        <IonPage>
            <IonHeader mode="ios">
                <HeaderSimple headerTitle="On Watch List" history={history} 
                        location={location} match={match}></HeaderSimple>
            </IonHeader>
            <IonContent fullscreen>
            {neededList.length > 0 &&
                <LogItemList resultList={neededList} history={history} location={location} match ={match} refresh={refresh}></LogItemList> 
            }
            {neededList.length === 0 &&
                     <IonItem className="my-ion-item-noopen">
                     <IonIcon icon={alertCircleOutline} slot="start" color="primary" />
                     <IonLabel color="primary">No pinned activity log entries.</IonLabel>
                   </IonItem>
            }
            </IonContent>
            <IonLoading mode="ios"
                cssClass='my-loading'
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={'Getting data...'}
            />
        </IonPage>
    );
};
export default WatchResults;